// "use client";
// import { useState } from "react";
// import { motion } from "framer-motion";
// import { useInView } from "framer-motion";
// import { useRef } from "react";
// import Tag from "../ui/tag";
// import { IoSparkles } from "react-icons/io5";
// import AnimatedIcon from "../ui/animated-icon";
// import siteData from "../../data/site-data";
// import {
//   DataScienceIcon,
//   NetworkIcon,
//   DigitalEnterpriseIcon,
//   DevOpsIcon,
//   CloudIcon,
//   CustomerExperienceIcon,
// } from "../icons";
// import {
//   staggerContainer,
//   staggerItem,
//   fadeInUp,
//   cardHover,
//   textReveal,
// } from "../../lib/animations";
// import CustomModal from "../modal/modal";
// import { modalDataMap } from "../../data/site-data";
// import { MdArrowOutward } from "react-icons/md";

// // Icon mapping function
// const getIconComponent = (iconName: string) => {
//   const iconMap: {
//     [key: string]: React.ComponentType<{ className?: string }>;
//   } = {
//     DataScienceIcon,
//     NetworkIcon,
//     DigitalEnterpriseIcon,
//     DevOpsIcon,
//     CloudIcon,
//     CustomerExperienceIcon,
//   };

//   return iconMap[iconName] || DataScienceIcon; // Default fallback
// };

// export default function Portfolio() {
//   const { portfolio } = siteData;
//   const ref = useRef(null);
//   const isInView = useInView(ref, { once: true, amount: 0.1 });
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedModalData, setSelectedModalData] = useState(
//     modalDataMap["default"]
//   );

//   return (
//     <motion.section
//       ref={ref}
//       className="py-20 bg-[#F5F5F7]"
//       initial="hidden"
//       animate={isInView ? "visible" : "hidden"}
//       variants={staggerContainer}
//     >
//       <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
//         {/* Header Section */}
//         <motion.div className="text-center mb-16" variants={staggerContainer}>
//           {/* Top Tag */}
//           <motion.div className="mb-6" variants={fadeInUp}>
//             <Tag
//               icon={
//                 <AnimatedIcon animation="pulse" className="text-primary">
//                   <IoSparkles />
//                 </AnimatedIcon>
//               }
//               text={portfolio.tag.text}
//               bgColor="light"
//               textColor="primary"
//               borderColor="secondary"
//             />
//           </motion.div>

//           {/* Main Headline */}
//           <motion.h2
//             className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 leading-tight"
//             variants={textReveal}
//           >
//             {portfolio.title}
//           </motion.h2>

//           {/* Descriptive Text */}
//           <motion.p
//             className="text-lg text-text mb-8 max-w-3xl mx-auto leading-relaxed"
//             variants={textReveal}
//           >
//             {portfolio.description}
//           </motion.p>
//         </motion.div>

//         {/* Application Cards Grid */}
//         <motion.div
//           className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
//           variants={staggerContainer}
//         >
//           {portfolio.applications.map((app, index) => {
//             const IconComponent = getIconComponent(app.icon);

//             return (
//               <motion.div
//                 key={app.id}
//                 className="bg-light border border-secondary p-6 rounded-lg shadow-sm relative cursor-pointer "
//                 variants={staggerItem}
//                 custom={index}
//                 whileHover={{
//                   y: -8,
//                   boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
//                   transition: { duration: 0.3, ease: "easeOut" },
//                 }}
//                 initial="initial"
//               >
//                 <motion.div
//                   className="content-group"
//                   whileHover={{ x: 5 }}
//                   transition={{ duration: 0.3 }}
//                   onClick={() => {
//                     const modalKey = app.id || "default";
//                     setSelectedModalData(
//                       modalDataMap[modalKey] || modalDataMap["default"]
//                     );
//                     setIsModalOpen(true);
//                   }}
//                 >
//                   {/* Icon */}
//                   <div className="mb-4 flex justify-between ">
//                     <AnimatedIcon className="w-6 h-6 text-primary">
//                       <IconComponent />
//                     </AnimatedIcon>
//                     <MdArrowOutward />
//                   </div>

//                   {/* Title */}
//                   <span className="flex items-center justify-between">
//                     <h3 className="text-xl font-bold text-foreground mb-3  ">
//                       {app.title}
//                     </h3>
//                   </span>

//                   {/* Description */}
//                   <p className="text-text leading-relaxed mb-4">
//                     {app.description}
//                   </p>

//                   {/* Tags */}
//                   <div className="flex flex-wrap gap-2">
//                     {app.tags.map((tag, tagIndex) => (
//                       <span
//                         key={tagIndex}
//                         className="text-sm text-primary font-medium"
//                       >
//                         {tag}
//                       </span>
//                     ))}
//                   </div>
//                 </motion.div>
//               </motion.div>
//             );
//           })}
//         </motion.div>
//       </div>
//       <CustomModal
//         open={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//         data={selectedModalData}
//       />
//     </motion.section>
//   );
// }
"use client";

import { useState } from "react";
import Link from "next/link";
import {
  Code2,
  Brain,
  Smartphone,
  LayoutDashboard,
  Map,
  Rocket,
} from "lucide-react";

const iconComponents = {
  "code-2": Code2,
  brain: Brain,
  smartphone: Smartphone,
  "layout-dashboard": LayoutDashboard,
  map: Map,
  rocket: Rocket,
};

export default function CoreServices() {
  const [hoveredCard, setHoveredCard] = useState<string | null>(null);

  const services = [
    {
      id: "mvp-development",
      title: "MVP Development",
      description:
        "Turn your idea into a launch-ready product with a scalable foundation designed for real users and future growth.",
      icon: { name: "rocket", tone: "blue" },
      cta: "Launch your MVP →",
      link: "/service/custom-software",
    },

    {
      id: "saas-platforms",
      title: "SaaS Platform Development",
      description:
        "Custom SaaS products built for performance, scalability, and long-term maintainability.",
      icon: { name: "layout-dashboard", tone: "purple" },
      cta: "Build your SaaS →",
      link: "/service/saas-platforms",
    },

    {
      id: "ai-products",
      title: "AI Product Development",
      description:
        "AI assistants, automation systems, and intelligent workflows embedded directly into your products.",
      icon: { name: "brain", tone: "purple" },
      cta: "Explore AI solutions →",
      link: "/service/ai-product-development",
    },

    {
      id: "web-mobile",
      title: "Web & Mobile Applications",
      description:
        "Modern web and mobile apps designed to deliver exceptional user experiences across every device.",
      icon: { name: "smartphone", tone: "cyan" },
      cta: "View app solutions →",
      link: "/service/web-mobile",
    },

    {
      id: "product-design",
      title: "Branding and Product Design",
      description:
        "Improve design, architecture, and user experience as your product starts to attract more users.",
      icon: { name: "code-2", tone: "green" },
      cta: "Scale with confidence →",
      link: "/service/product-design",
    },

    {
      id: "product-strategy",
      title: "Product Strategy & Consulting",
      description:
        "Technical planning, architecture reviews, and product roadmaps that help founders make better decisions.",
      icon: { name: "map", tone: "amber" },
      cta: "Book a strategy session →",
      link: "/service/consulting",
    },

  ];

  return (<section className="py-16 md:py-20 bg-white"> <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

    {/* Header */}
    <div className="text-center mb-12">
      <h2
        className="text-[28px] sm:text-[34px] md:text-[40px] text-[#0F172A] mb-3"
        style={{
          fontWeight: 600,
          lineHeight: 1.18,
          letterSpacing: "-0.015em",
        }}
      >
        Solutions We Offer
      </h2>

      {/* Accent Line */}
      <div
        className="mx-auto mb-4"
        style={{
          width: "48px",
          height: "3px",
          background:
            "linear-gradient(90deg, #F2A65A, #7A6FF0)",
          borderRadius: "999px",
        }}
      />

      <p
        className="text-[16px] md:text-[17px] text-[#64748B] max-w-[720px] mx-auto"
        style={{
          fontWeight: 400,
          lineHeight: 1.6,
        }}
      >
        From AI solutions to enterprise software, we deliver digital products tailored to your business goals.
      </p>
    </div>

    {/* Cards */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
      {services.map((service) => {
        const IconComponent =
          iconComponents[
          service.icon.name as keyof typeof iconComponents
          ];

        const isHovered =
          hoveredCard === service.id;

        return (
          <Link
            key={service.id}
            href={service.link}
            onMouseEnter={() =>
              setHoveredCard(service.id)
            }
            onMouseLeave={() =>
              setHoveredCard(null)
            }
            className="rounded-2xl p-4 sm:p-6 h-full flex flex-col transition-all duration-300 ease-out"
            style={{
              background: isHovered
                ? "linear-gradient(180deg, rgba(242,166,90,0.06), rgba(122,111,240,0.04))"
                : "#FFFFFF",
              border: isHovered
                ? "1px solid rgba(122,111,240,0.25)"
                : "1px solid rgba(0,0,0,0.04)",
              transform: isHovered
                ? "translateY(-6px)"
                : "translateY(0)",
              boxShadow: isHovered
                ? "0 20px 40px rgba(15,23,42,0.08)"
                : "0 2px 8px rgba(0,0,0,0.02)",
            }}
          >
            {/* Icon */}
            <div
              className="w-12 h-12 rounded-xl flex items-center justify-center mb-4 transition-all duration-300"
              style={{
                background:
                  "linear-gradient(135deg, rgba(242,166,90,0.18), rgba(122,111,240,0.18))",
                border: isHovered
                  ? "2px solid #F2A65A"
                  : "2px solid transparent",
              }}
            >
              <IconComponent
                className="w-5 h-5"
                style={{
                  color: "#7A6FF0",
                }}
              />
            </div>

            {/* Title */}
            <h3
              className="text-[17px] mb-3 transition-colors duration-300"
              style={{
                fontWeight: 600,
                color: isHovered
                  ? "#7A6FF0"
                  : "#0F172A",
              }}
            >
              {service.title}
            </h3>

            {/* Description */}
            <p
              className="text-[14px] text-[#475569] mb-4 flex-grow"
              style={{
                fontWeight: 400,
                lineHeight: 1.6,
              }}
            >
              {service.description}
            </p>

            {/* CTA */}
            <p
              className="text-[13px] mt-auto transition-all duration-200"
              style={{
                fontWeight: 500,
                color: "#7A6FF0",
                textDecoration: isHovered
                  ? "underline"
                  : "none",
              }}
            >
              {service.cta}
            </p>
          </Link>
        );
      })}
    </div>

    {/* Footer Note */}
    {/* <p
      className="text-center text-sm text-[#64748B] mt-10"
      style={{
        fontWeight: 400,
      }}
    >
      Every engagement is designed around product success,
      scalability, and long-term ownership.
    </p> */}
  </div>
  </section>

  );
}